export const SEARCHLIGHT_ACTION_TYPE = {
  INIT_SEARCHLIGHT_DISPATCHER: 'INIT_SEARCHLIGHT_DISPATCHER',
  SEARCHLIGHT_CHANGE_GAME_SESSION: 'SEARCHLIGHT_CHANGE_GAME_SESSION',
  DISPATCH_EVENT: 'DISPATCH_EVENT',
  SEARCHLIGHT_DISPATCH_EVENT: 'SEARCHLIGHT_DISPATCH_EVENT',
  SET_SEARCHLIGHT_DATA: 'SET_SEARCHLIGHT_DATA',
  CLEAR_SEARCHLIGHT_DATA: 'CLEAR_SEARCHLIGHT_DATA',
  SET_QUEST_SESSION_ID: 'SET_QUEST_SESSION_ID',
  CLEAR_QUEST_SESSION_ID: 'CLEAR_QUEST_SESSION_ID',
  SET_USER_ID: 'SET_USER_ID',
  REPORT_LOGIN_EVENT: 'REPORT_LOGIN_EVENT',
  REPORT_METRIC: 'REPORT_METRIC',
  SET_IDENTITY: 'SET_IDENTITY',
  SET_SOURCE_ID: 'SET_SOURCE_ID',
  REPORT_APP_LOADED: 'REPORT_APP_LOADED',
  SET_SKILL_MAP: 'SET_SKILL_MAP',
};

export const dispatchEvent = (
  eventType,
  gameId,
  {
    writtenByAPI = false, // If true, sends /writeResult outside of ROUND_START or ROUND_COMPLETE Searchlight events
    writtenToAPI = false, // If true, sends /writeResultItems (Embedded Measurement)
    ...details
  } = {}, // this destructuring allows `writtenByAPI`, `writtenToAPI` to be sent in details arg
  logMessage = null,
  searchlight,
) => ({
  type: SEARCHLIGHT_ACTION_TYPE.SEARCHLIGHT_DISPATCH_EVENT,
  payload: {
    application: {
      gameId,
      eventType,
      writtenByAPI,
      writtenToAPI,
      details,
    },
    log: logMessage ? {
      level: 'info',
      logType: 'communication',
      message: logMessage,
    } : null,
    searchlight,
  },
});

// Takes an object instead of clearly defined arguments. For use only in older games and
// rare cirumstances where you want full control over the searchlight event object
export const dispatchEventObj = (payload = {}) => ({
  type: SEARCHLIGHT_ACTION_TYPE.SEARCHLIGHT_DISPATCH_EVENT,
  payload,
});
